<div class="properties-edit-container">
  <div class="properties-list">
    @if (propertyKeys().length === 0) {
      <div class="empty-state">
        <i class="pi pi-info-circle"></i>
        <p i18n="@@propertiesEdit.empty">No properties defined</p>
      </div>
    }

    @for (key of propertyKeys(); track key) {
      <app-property-editor
        [schema]="combinedSchema()[key]"
        [value]="localValues()[key]"
        [title]="getPropertyTitle(key, combinedSchema()[key])"
        [subtitle]="getPropertySubtitle(combinedSchema()[key])"
        [disabled]="disabled()"
        (valueChange)="onPropertyChange(key, $event)">
      </app-property-editor>
    }
  </div>
</div>
